import React from "react";
import AutomationList from "../shared/components/AutomationList";
import { WORKFLOW_CATEGORY } from "../workflow/utils/enums";

const DealsAutomation: React.FC = () => {
  return (
    <AutomationList
      workflowCategory={WORKFLOW_CATEGORY.DEAL}
      title="Deals Automation"
      breadcrumb="Deals"
      module="deals"
    />
  );
};

export default DealsAutomation;
